import React, { ComponentProps } from 'react';

export const ShieldIcon = (props: ComponentProps<'svg'>) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="57"
            height="57"
            fill="none"
            viewBox="0 0 57 57"
            {...props}
        >
            <g clipPath="url(#a)">
                <path
                    fill="#06CC8A"
                    d="M48.147.5H8.853A3.5 3.5 0 0 0 5.377 4v14.607A42.607 42.607 0 0 0 27.963 56.36a1.096 1.096 0 0 0 1.074 0 42.606 42.606 0 0 0 22.586-37.753V4A3.5 3.5 0 0 0 48.147.5Zm-5.88 18.527L25.677 34.66a2.333 2.333 0 0 1-2.483.457 2.332 2.332 0 0 1-.76-.504l-5.6-5.6a2.333 2.333 0 0 1 1.656-3.98 2.333 2.333 0 0 1 1.657.69l3.92 3.967L39 15.69a2.335 2.335 0 1 1 3.267 3.337Z"
                />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="currentcolor" d="M.5.5h56v56H.5z" />
                </clipPath>
            </defs>
        </svg>
    );
};
